import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER =
    'requestNoSubmittedDraftClaimApplicationByUser';
const REQUEST_DRAFT_CLAIM_APPLICATION_BY_USER =
    'requestDraftClaimApplicationsByUser';
const REQUEST_DRAFT_CLAIM_APPLICATION_LIST_BY_USER =
    'requestDraftClaimApplicationListByUser';

export function requestNoSubmittedDraftClaimApplicationByUser(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/DraftClaimApplication/last`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(
        REQUEST_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchDraftClaimApplicationByUserSuccess(response)
                : actions.fetchDraftClaimApplicationByUserFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestDraftClaimApplicationByUser(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.GET_DRAFT_CLAIM_APPLICATION_BY_USER,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/DraftClaimApplication/ClaimApplication/${action.payload}`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_DRAFT_CLAIM_APPLICATION_BY_USER,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(
        REQUEST_DRAFT_CLAIM_APPLICATION_BY_USER,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchDraftClaimApplicationByUserSuccess(response)
                : actions.fetchDraftClaimApplicationByUserFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestDraftClaimApplicationListByUser(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/DraftClaimApplication`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_DRAFT_CLAIM_APPLICATION_LIST_BY_USER,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(
        REQUEST_DRAFT_CLAIM_APPLICATION_LIST_BY_USER,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchDraftClaimApplicationListByUserSuccess(response)
                : actions.fetchDraftClaimApplicationListByUserFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
